import { createDraftSafeSelector, createSlice, nanoid } from "@reduxjs/toolkit";

export const pushTxStatusThunk =
  ({ status, type, txHash }) =>
  (dispatch) => {
    const id = nanoid();
    dispatch(pushTxStatus({ id, status, type, txHash }));
    return id;
  };

const txStatusNotifierSlice = createSlice({
  name: "txStatusSlice",
  initialState: {
    stack: {},
  },
  reducers: {
    pushTxStatus(state, action) {
      state.stack[action.payload.id] = action.payload;
    },
    popTxStatus(state, action) {
      const id = action.payload.id;
      if (state.stack[id]) {
        delete state.stack[id];
      }
    },
    updateTxStatus(state, action) {
      const id = action.payload.id;
      if (state.stack[id]) {
        state.stack[id] = { ...state.stack[id], ...action.payload };
      }
    },
  },
});

export default txStatusNotifierSlice.reducer;
export const { pushTxStatus, popTxStatus, updateTxStatus } = txStatusNotifierSlice.actions;

export const selectTxStatusNotifier = (state) => state.txStatusSlice;

export const selectTxStatus = createDraftSafeSelector(
  (state) => selectTxStatusNotifier(state).stack,
  (stack) => {
    if (Object.entries(stack).length === 0) return null;
    return Object.entries(stack).map(([_, item]) => item);
  }
);
